import { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@hotjar/hotsauce';
import { withHighlight } from '../withHighlight';
import { EventsBinding } from './KeyboardShortcutEvents';

const PlayPauseReplayBtn = ({ isPlaying, isDone, disabled, onPlay, onPause, onReplay }) => {
  const { t } = useTranslation();
  let icon;
  let handleClick;
  let tooltipText;

  if (isDone) {
    icon = 'replay';
    handleClick = onReplay;
    tooltipText = t('common:player.replay-tooltip');
  } else if (isPlaying) {
    icon = 'pause_alt';
    tooltipText = t('common:player.pause-tooltip');
    handleClick = () => onPause && onPause(true, true);
  } else {
    icon = 'play_alt';
    tooltipText = t('common:player.play-tooltip');
    handleClick = onPlay;
  }

  return (
    <IconButton
      icon={icon}
      tooltipText={tooltipText}
      description={tooltipText}
      size="s"
      kind="ghost"
      isDisabled={disabled}
      onClick={handleClick}
      data-testid="player-btn-play-pause-replay"
    />
  );
};

PlayPauseReplayBtn.defaultProps = {
  disabled: false,
  onPlay: undefined,
  onPause: undefined,
  onReplay: undefined,
};

PlayPauseReplayBtn.propTypes = {
  isPlaying: PropTypes.bool.isRequired,
  isDone: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  onPlay: PropTypes.func,
  onPause: PropTypes.func,
  onReplay: PropTypes.func,
};

export const PlayPauseReplayButton = withHighlight(
  memo(PlayPauseReplayBtn),
  EventsBinding.PLAY_PAUSE,
);
